import React from 'react';

import {errorPagesConfigs} from './errors';
import {authPageConfig} from './auth';
import {profilePageConfig} from './profile';
import {healthPageConfig} from './health';
import Error403 from './errors/Error403';
import Error404 from './errors/Error404';

import {initialUrl} from 'shared/constants/AppConst';

const authorizedStructure = {
  fallbackPath: '/signin',
  unAuthorizedComponent: <Error403 />,
  routes: [...profilePageConfig, ...healthPageConfig],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authPageConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: '*',
      element: <Error404 />,
    },
  ]),
};

export {authorizedStructure, unAuthorizedStructure, anonymousStructure};
